/*
import {signInWithGoogle} from "./firebase";


function Login() {




  return (
    <div className="App">
      <button class="login-with-google-btn" onClick={signInWithGoogle}>
        Sign in with Google
      </button>



    </div>
  );
}

export default Login;*/


import React, {useEffect, useState} from 'react';
import { v4 as uuidv4 } from 'uuid';
import AuthService from "../services/auth/auth_service";
import Swiper from 'swiper/bundle'; // Import the Swiper bundle




function Login() {
  const [uuid, setUuid] = useState('');

  const generateUUID = () => {
    const newUUID = uuidv4();
    setUuid(newUUID);
  };
  const login = () => {
    AuthService.appUserLogin().then(r=>{
        console.log(r.data)
         localStorage.setItem("login", 'true');
         localStorage.setItem("uuid", r.data.uuid);
        window.location.reload()

    })
  };

  useEffect(() => {
    const swiper = new Swiper('.swiper-container', {
      direction: 'horizontal',
      slidesPerView: 1,
      loop: true,
      effect: 'fade',
      speed: 1000,
      navigation: {
        nextEl: '#main-slider__swiper-button-next',
        prevEl: '#main-slider__swiper-button-prev',
      },
      pagination: {
        el: '#main-slider-pagination',
        type: 'bullets',
        clickable: true,
      },
      autoplay: {
        delay: 5000,
      },
      touchEventsTarget: 'container',

    });

    // Cleanup when the component unmounts
    return () => {
      swiper.destroy();
    };
  }, []);


/*
function scrollHeader() {
  const header = document.querySelector('.header'); // Replace with the actual selector for your header element
  if (header) {
    if (window.scrollY > 100) {
      header.classList.add('header--scroll');
    } else {
      header.classList.remove('header--scroll');
    }
  }
}

// Add an event listener to call scrollHeader when the window is scrolled
window.addEventListener('scroll', scrollHeader);
*/




  return (
   /* <div>
      <button onClick={generateUUID}>Generate UUID</button>
      <p>Generated UUID: {uuid}</p>
         <button onClick={login}>Loging</button>
    </div>*/
<div style={{position:'absolute', top:0, bottom:0, left:0, right:0, backgroundColor:'#A3C6C4'}}>
  <section className="main-slider " >
      <div className="swiper-container thm-swiper__slider " >
        <div className="swiper-wrapper ">
          <div className="swiper-slide ">
            <div
              className="image-layer "
              style={{
                backgroundImage: 'url(https://images.unsplash.com/photo-1521737852567-6949f3f9f2b5?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2047&q=80)',
              }}
            ></div>
            <div className="main-slider__social">
              <a href="# text-red">facebook</a>
              <a href="#">twitter</a>
              <a href="#">instagram</a>
            </div>
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="main-slider__content">
                    <div className="main-slider__title-box-1">
                      <h2>Karibu <br /> Maokoto <br /> Og</h2>
                      <div className="main-slider__title-box-2">
                        <h2>Karibu <br /> Maokoto <br /> Og</h2>
                      </div>
                    </div>
                    <a onClick={login} className="thm-btn">Get started</a>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="swiper-slide">
            <div
              className="image-layer"
              style={{
                backgroundImage: 'url(https://images.unsplash.com/photo-1553877522-43269d4ea984?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80)',
              }}
            ></div>
            <div className="main-slider__social">
              <a href="#">facebook</a>
              <a href="#">twitter</a>
              <a href="#">instagram</a>
            </div>
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="main-slider__content">
                    <div className="main-slider__title-box-1">
                      <h2>Bidhaa <br />Kwa bei  <br /> Nafuu</h2>
                      <div className="main-slider__title-box-2">
                        <h2>Bidhaa <br /> Kwa bei <br /> Nafuu</h2>
                      </div>
                    </div>
                    <a onClick={login} className="thm-btn">Get started</a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="swiper-slide">
            <div
              className="image-layer"
              style={{
                backgroundImage: 'url(https://images.unsplash.com/photo-1551845811-f63135691a4b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80)',
              }}
            ></div>
            <div className="main-slider__social">
              <a href="#">facebook</a>
              <a href="#">twitter</a>
              <a href="#">instagram</a>
            </div>
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="main-slider__content">
                    <div className="main-slider__title-box-1">
                      <h2>Delivery <br />uhakina <br /> Sana</h2>
                      <div className="main-slider__title-box-2">
                        <h2>Delivery <br /> uhakina <br /> Sana</h2>
                      </div>
                    </div>
                    <a onClick={login} className="thm-btn">Get started</a>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


       {/* <div className="slider-bottom-box clearfix">
          <div className="swiper-pagination" id="main-slider-pagination"></div>
          <div className="main-slider__nav">
            <div className="swiper-button-prev" id="main-slider__swiper-button-next">
              <svg width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <g fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                  <path data-name="Right" d="m7.6 7-5.1 5 5.1 5" />
                  <path d="M21.5 12H4.8" />
                </g>
              </svg>
            </div>
            <div className="swiper-button-next" id="main-slider__swiper-button-prev">
              <svg width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <g fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                  <path data-name="Right" d="m16.4 7 5.1 5-5.1 5" />
                  <path d="M2.5 12h16.7" />
                </g>
              </svg>
            </div>
          </div>
        </div>*/}



      </div>
    </section>
  </div>

  );
}

export default Login;
